<template>
  <div>
    <v-switch v-model="switch1" inset :label="`${switch1  === true ? `${OnName}` : `${OffName}`}`"></v-switch>
  </div>
</template>

<script>
export default {
  props: ["emitter", "ikey", "getData", "putData","OnName","OffName"],
  data() {
    return {
      switch1: false
    };
  },
  methods: {
    update(newVal, oldVal) {
      if (this.ikey) {
        this.putData(this.ikey, this.switch1);
      }
      if (this.emitter !== undefined) this.emitter.trigger("process");
    }
  },
  watch: {
    switch1: function(newVal, oldVal) {
      this.update(newVal, oldVal);
      
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.switch1 = this.getData(this.ikey);
    }
  }
};
</script>

<style>
</style>
